













































import {defineComponent} from "@vue/composition-api"
import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {leave} from "@/apps/MyStudyChoiceOnboardingWidget/composables/transition"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ActionTree, GetterTree} from "vuex"
import CloseButtonAtom from "@/shared/components/atoms/CloseButtonAtom.vue"
import ButtonComponent from "@/shared/components/Button.vue"
import HeaderNavigation from "./HeaderNavigation.vue"
import FooterNavigation from "./FooterNavigation.vue"
import ModalComponent from "./modal/ModalComponent.vue"
import Welcome from "./steps/Welcome.vue"
import Activities from "./steps/Activities.vue"
import Activation from "./steps/Activation.vue"
import AvailableActivity from "./steps/molecules/Available.vue"
import SubscribedActivity from "./steps/molecules/Subscribed.vue"

export default defineComponent({
    name: "OnboardingModal",
    components: {
        FooterNavigation,
        ButtonComponent,
        CloseButtonAtom,
        ModalComponent,
        HeaderNavigation,
        Activation,
        Activities,
        SubscribedActivity,
        AvailableActivity,
        Welcome
    },
    setup: () => {
        const {
            setNextStep, setPreviousStep, setOnboardingIsActive
        } = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setNextStep', 'setPreviousStep', 'setOnboardingIsActive'
        ])
        const {
            getReverse,
            getSteps,
            getCanContinue,
            getActiveStep,
            getActiveSubStep,
            getActiveStepIndex,
            getActiveSubStepIndex
        } = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getReverse', 'getSteps', 'getCanContinue', 'getActiveStep', 'getActiveSubStep', 'getActiveStepIndex', 'getActiveSubStepIndex'
        ])

        return {
            getReverse,
            getCanContinue,

            getSteps,
            getActiveStep,
            getActiveSubStep,
            getActiveStepIndex,
            getActiveSubStepIndex,

            setNextStep,
            setPreviousStep,
            setOnboardingIsActive,

            leave
        }
    }
})
